export const locationMapping = {
  'st_polten': 'St. Polten',
  'vienna': 'Vienna',
  'hong_kong': 'Hong Kong',
  'poughkeepsie': 'Poughkeepsie',
  'new_york_city': 'New York City',
  'asheville': 'Asheville',
  'oslo': 'Oslo',
  'ann_arbor': 'Ann Arbor',
  'taiwan': 'Taiwan',
  'miami_beach': 'Miami Beach',
  'new_jersey': 'New Jersey',
  'automated_scraper': 'Search Bot'
}; 